module.exports = __webpack_public_path__ + "img/tank_image.b55e2793.gif";